export default {
    goodsSku: {
        page: {
            commonSKU: 'Add SKU',
            threeParties: 'Sync third-party',
            packageSKU: 'Add Sales Kit',
            Set: 'Set',
            submitTip: 'Confirm submission?',
            Sync: 'Sync',
            SelectChannel: 'Select channel',
            synchronizeProducts: 'Please select a third-party channel that needs to synchronize products',
            SKU: 'This SKU cannot be pushed!',
            SKUNO: 'This SKU has been pushed and cannot be pushed again!',

            ExpirationStatus: 'Expiration status',
            CertificatePeriod: 'Certificate validity period',
        },
        detail: {
            hsCode: 'HS Code',
            originPlace: 'Country Of Origin',
            barcodeTip: 'Contact the customer before changing the barcode of an in-stock item.',
            BasicInformation: 'SKU Information',
            SaveDraft: 'Save as Draft',
            Description: 'Description',
            ProductType: 'Product Type',
            ProductClassification: 'Product category',
            Barcode: 'Barcode',
            Supplier: 'Supplier',
            PurchasingDepartment: 'Purchasing Department',
            Purchaser: 'Purchasing agent',
            Brand: 'Brand',
            packagingBarcode: 'Outer packaging barcode',
            SeasonalProducts: 'Seasonal products',
            Merchandiser: 'Ebay Merchandiser',
            Merchandiser2: 'Amz Merchandiser',
            ContinueSell: 'Continue to sell',
            Currency: 'Currency',
            Price: 'Price',
            InventoryProducts: 'Inventory Products',
            PurchasedItems: 'Purchased Item',
            SellingItems: 'Sale item',
            Fragile: 'Fragile',
            DangerousGoods: 'Dangerous Goods',
            Flammable: 'Flammable',
            Picture: 'Picture',
            AttributeTable: 'DIM/ WT Information',
            length: 'Unit/L',
            width: 'Unit/W',
            height: 'Unit/H',
            weight: 'Unit/WT',
            UnitVolume: 'Unit Volume',
            qty: 'Quantity',
            cartonLength: 'Carton/L',
            cartonWidth: 'Carton/W',
            cartonHeight: 'Carton/H',
            cartonWeight: 'Carton/WT',
            cartonVolume: 'Box Volume',
            stockQty: 'Stock Qty',

            costPrice: 'Cost price',
            salesPrice: 'Sales price',
            activityPrice: 'Activity price',
            marketPrice: 'market value',
            distributionPrice: 'Distribution price',
            wholesalePrice: 'Wholesale price',
            clearingPrice: 'Settlement price',
            CertificateList: 'Certificate List',
            CertificateName: 'Certificate name',
            CertificatePeriod: 'Certificate validity period',
            CertificateRemarks: 'Certificate remarks',
            PleaseUpload: 'Please upload first',
            PleaseContent: 'Please enter the certificate content',
            leastCertificate: 'At least one certificate',
            UseSystemBarcode: 'Use system barcode',
            Length: 'Length',
            Width: 'Width',
            Height: 'Height',
            Weight: 'Weight',
            Size: 'Size',
            Volume: 'Volume',
            skuDesc: 'Product Description',
            itemPerCarton: 'Unit per Carton',
            isWine: 'Is It Wine',
            valueDa: 'Please enter a value greater than 0',
            oversizeDimensionConfirm: 'The entered dimensions are unusually large. Please confirm they are correct. The current unit is cm.'
        },
        package: {
            BasicInformation: 'Sales Kit Information',
            packageName: 'Package Name',
            packageSkuCode: 'Package SKU Code',
            costPrice: 'Cost Price',
            salesPrice: 'Sales Price',
            packageProductMsg: 'Sales Kit Included Products included in the package',
            delete: 'Delete selected ',
            skuName: 'SKU Product Name',
            Qty: 'Qty quantity in package',
            msgErrorText: 'The quantity of goods in the package cannot be empty or 0',
            msgErrorText2: "Reminder: In the Sales Kit, you've entered a total of 1 item. Please verify the quantity and make adjustments if needed."
        }
    }
};
